module.exports = __webpack_public_path__ + "img/icon-student.68d6d0a.png";